// @ts-check
import morningHorizon from "../morning-horizon/index.js";

import aliases from "./aliases.js";
import palette from "./palette.js";
import tokens from "./tokens.js";

/** @type import("../../types/themes").ThemeExtension */
export default {
  name: "Evening Horizon",
  id: "eveningHorizon",
  sapId: "sap_horizon_dark",
  extend: morningHorizon,
  thumbnail: ["https://assets.emarsys.net/ui/static/images/theme-thumbnails/evening-horizon.png"],
  status: "production_ready",
  mode: "dark",
  palette,
  aliases,
  tokens,
};
